import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { MatButton } from '@angular/material/button';

@Component({
    selector: 'app-confirm-modal',
    templateUrl: './confirm-modal.component.html',
    styleUrls: [ './confirm-modal.component.scss' ],
    imports: [ MatButton, MatDialogTitle, MatDialogContent, MatDialogActions ]
})
export class ConfirmModalComponent implements OnInit {

    public title: string;
    public text: string;
    public yesCaption: string = $localize`Yes`;
    public noCaption: string = $localize`No`;
    protected action: () => void;

    constructor(@Inject(MAT_DIALOG_DATA) data: {
        title: string,
        text: string,
        yesCaption: string,
        noCaption: string,
        action: () => void
    },          private dialogRef: MatDialogRef<ConfirmModalComponent>) {
        this.title = data.title;
        this.text = data.text;
        if (data.yesCaption) {
            this.yesCaption = data.yesCaption;
        }
        if (data.noCaption) {
            this.noCaption = data.noCaption;
        }
        this.action = data.action;
    }

    ngOnInit(): void {
    }

    yes(): void {
        this.dialogRef.close(true);
        this.action();
    }

    no(): void {
        this.dialogRef.close(false);
    }

}
